package com.trevorwiebe.timesheet.core.domain

actual fun registerPushToken() {
    // Web FCM requires a service worker; not in scope for initial web support
}
